import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "80",
  height: "80",
  fill: "#F1F5F9",
  rx: "40"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#CBD5E1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M34.18 34a6 6 0 0 1 11.66 2c0 4-6 6-6 6m.16 8h.02M22 31.883v16.234c0 .685 0 1.028.101 1.334a2 2 0 0 0 .428.727c.218.237.518.404 1.117.736l14.8 8.223c.567.315.85.472 1.151.534.266.055.54.055.806 0 .3-.062.584-.22 1.151-.534l14.8-8.223c.6-.333.899-.499 1.117-.736a2 2 0 0 0 .428-.727c.101-.306.101-.649.101-1.334V31.883c0-.685 0-1.028-.101-1.334a2 2 0 0 0-.428-.728c-.218-.236-.518-.403-1.117-.736l-14.8-8.222c-.567-.315-.85-.472-1.151-.534a2 2 0 0 0-.806 0c-.3.062-.584.22-1.151.534l-14.8 8.223c-.6.332-.899.499-1.117.735-.193.21-.339.458-.428.728-.101.306-.101.649-.101 1.334"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }